import React from 'react'
import { modals } from '@mantine/modals'
import { ActionIcon, Box, Text } from '@mantine/core'
import { IconAlertTriangleFilled } from '@tabler/icons-react'
import { notificationSuccess, notificationError } from '../Notification'


export const modalConfirmTransaction = ( title, id, name, functionDelete, reloadData ) => {
  
  const handleDeleteData = async (id) => {
    try {
      const response = await functionDelete(id)
      if (response) {
        notificationSuccess(`Transaksi Berhasil Dibatalkan`,  `Transaksi ${title} berhasil dibatalkan`)
        reloadData()
        modals.closeAll()
      }
    } catch (error) {
      console.log(error)
      notificationError(`Transaksi Gagal Dibatalkan`, `Transaksi ${title} gagal dibatalkan`)
    }
  }

  return modals.openConfirmModal({
    centered: 'true',
    closeOnConfirm: false,
    children: (
      <Box>
        <Box ta='center'>
          <ActionIcon variant='transparent' color='red' size={120}>
            <IconAlertTriangleFilled stroke={1.5} size={120} />
          </ActionIcon>
          <Text fw={500} mb={4}>Apakah anda yakin ingin membatalkan transaksi ini ? </Text>
          <Text fw='bold' mb={14}>"{name}"</Text>
          <Text fz='xs' c='gray.6' mb={20}>Tolong diperhatikan. transaksi yang sudah di batalkan tidak dapat di kembalikan lagi.</Text>
        </Box>
      </Box>
    ),
    labels: { confirm: 'Iya', cancel: "Tidak" },
    confirmProps: { color: 'red' },
    onConfirm: () => handleDeleteData(id),
  })
}
